import { FC, memo } from "react";

import { SubscriptionContractStatus } from "@/apis/clients";
import { subscriptionOrderStatusToString } from "@/libs/enums/enumStrings";

interface Props {
  statusVal: SubscriptionContractStatus;
  className?: string;
  divClassName?: string;
}

function badgeContainerClasses(s: SubscriptionContractStatus): string {
  const base =
    "px-2 py-px rounded-[100px] inline-flex justify-center items-center overflow-hidden";
  switch (s) {
    case SubscriptionContractStatus.ACTIVE:
      return `w-24 h-5 bg-emerald-400/20 ${base}`;
    case SubscriptionContractStatus.CANCELLED:
      return `w-24 h-6 bg-zinc-200 ${base}`;
    case SubscriptionContractStatus.CANCELLATION_ACCEPTED:
      return `w-24 h-6 bg-amber-400/20 ${base}`;
    case SubscriptionContractStatus.PAYMENT_FAILED:
      return `self-stretch bg-red-100 ${base}`;
    case SubscriptionContractStatus.TRIALING:
      return `w-24 h-5 bg-blue-100 ${base}`;
    default:
      return `w-24 h-5 bg-gray-100 ${base}`;
  }
}

function badgeTextClasses(s: SubscriptionContractStatus): string {
  const base =
    "text-center justify-start text-xs font-bold font-['Noto_Sans_JP'] leading-4";
  switch (s) {
    case SubscriptionContractStatus.ACTIVE:
      return `text-teal-600 ${base}`;
    case SubscriptionContractStatus.CANCELLED:
      return `text-neutral-500 ${base}`;
    case SubscriptionContractStatus.CANCELLATION_ACCEPTED:
      return `text-amber-500 ${base}`;
    case SubscriptionContractStatus.PAYMENT_FAILED:
      return `text-rose-500 ${base}`;
    case SubscriptionContractStatus.TRIALING:
      return `text-blue-700 ${base}`;
    default:
      return `text-gray-500 ${base}`;
  }
}

const SubscriptionOrderStatusBadgeBase: FC<Props> = ({
  className,
  statusVal,
  divClassName = "",
}) => {
  return (
    <div className={divClassName}>
      <div className={[badgeContainerClasses(statusVal), className].join(" ").trim()}>
        <div className={badgeTextClasses(statusVal)}>
          {subscriptionOrderStatusToString(statusVal)}
        </div>
      </div>
    </div>
  );
};

export const SubscriptionOrderStatusBadge = memo(
  SubscriptionOrderStatusBadgeBase,
);
